module.exports = __webpack_public_path__ + "static/img/import_csv.afde8c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/import_csv.png
// module id = G96f
// module chunks = 0